import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-remortgage',
  templateUrl: './remortgage.component.html',
  styleUrls: ['./remortgage.component.css']
})
export class RemortgageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
